var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": "80%"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('transition', {
    attrs: {
      "appear": "",
      "name": "popPromptBottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$attrs.show,
      expression: "$attrs.show"
    }],
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$lang("Share invite link")))]), _c('div', {
    staticClass: "btn-share",
    style: {
      background: _vm.themeMainColor(_vm.theme).main
    },
    on: {
      "click": _vm.onShare
    }
  }, [_vm._v(_vm._s(_vm.$lang("Share")))]), _c('div', {
    staticClass: "code"
  }, [_c('div', {
    staticClass: "code__title"
  }, [_vm._v(_vm._s(_vm.$lang("secret code to invite")))]), _c('div', {
    staticClass: "code__value"
  }, [_vm._v(_vm._s(_vm.userData.ref_code))]), _c('div', {
    directives: [{
      name: "copy",
      rawName: "v-copy",
      value: `https://t.me/${_vm.setting.botname}/${_vm.setting.app}?startapp=ref_${_vm.userData.ref_code}`,
      expression: "`https://t.me/${setting.botname}/${setting.app}?startapp=ref_${userData.ref_code}`"
    }],
    staticClass: "btn-copy"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-copy"
    }
  }), _vm._v(" " + _vm._s(_vm.$lang("Copy")) + " ")], 1)]), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$lang("Recommend if you shared to groups that blocks links")))])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };